
export default function Testimonials() {
  const testimonials = [
    {
      text: "Ich hätte nie gedacht, dass eine KI mir helfen kann, mich selbst so gut zu verstehen.",
      author: "Sarah M.",
      role: "Unternehmerin"
    },
    {
      text: "Endlich ein Tool, das ehrlich, neutral und immer da ist.",
      author: "Michael K.",
      role: "Führungskraft"
    },
    {
      text: "Es fühlt sich an, als würde ich mit jemandem sprechen, der mich nicht bewertet – sondern versteht.",
      author: "Anna L.",
      role: "Selbstständige"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Was Nutzer über Mindshift AI sagen
          </h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 relative">
              <div className="text-teal-500 text-4xl mb-4">"</div>
              <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">
                {testimonial.text}
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-blue-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.author}</div>
                  <div className="text-gray-600 text-sm">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
